import { Book } from "lucide-react";
import { useBundleTree } from "../bundleTreeStore";

type ViewVolumeProps = {
  groupId: string;
};

export const ViewVolume = ({ groupId }: ViewVolumeProps) => {
  const group = useBundleTree((s) => s.config.groups[groupId]);

  return (
    <div className="flex items-center gap-2 px-3 py-2 rounded-lg border bg-blue-50/60 border-blue-200">
      <Book className="h-4 w-4 text-blue-500 shrink-0" />
      <span className="text-sm font-semibold text-blue-700">{group.title}</span>
    </div>
  );
};
